<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col>
            
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    data: Object,
    index: Number
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    update: function(val) {
      this.$emit("change", val);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
